import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "./context/AppContext";
import { Nav } from "./components/Nav";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import Landing from "./pages/Landing";
import WalletPage from "./pages/WalletPage";
import CatalogPage from "./pages/CatalogPage";
import TutorPage from "./pages/TutorPage";
import CallPage from "./pages/CallPage";
import PostCallPage from "./pages/PostCallPage";
import DashboardPage from "./pages/DashboardPage";
import BookingPage from "./pages/BookingPage";
import ReadyPage from "./pages/ReadyPage";
import PanelPage from "./pages/PanelPage";
import ContactsPage from "./pages/ContactsPage";
import GuideThanksPage from "./pages/GuideThanksPage";
import PrivacyPage from "./pages/PrivacyPage";
import AdminPage from "./pages/AdminPage";
import { AdminSessionGate } from "./components/admin/AdminSessionGate";
import "./App.css";

const toasterOptions = {
  style: {
    background: "#1E1924",
    color: "#FAF9FB",
    border: "1px solid #1E1924",
    fontFamily: "Outfit, sans-serif",
  },
};

const Chrome = ({ children, hideFooter = false }) => (
  <>
    <Nav />
    {children}
    {!hideFooter && <Footer />}
  </>
);

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={toasterOptions}
        />
        <div className="App">
          <Routes>
            <Route path="/" element={<Chrome><Landing /></Chrome>} />
            <Route path="/saldo" element={<Chrome><WalletPage /></Chrome>} />
            <Route path="/tutores" element={<Chrome><CatalogPage /></Chrome>} />
            <Route path="/tutor/:id" element={<Chrome><TutorPage /></Chrome>} />
            <Route path="/llamada/:id" element={<CallPage />} />
            <Route path="/post-clase/:id" element={<Chrome><PostCallPage /></Chrome>} />
            <Route path="/dashboard" element={<Chrome><DashboardPage /></Chrome>} />
            <Route path="/reservar" element={<Chrome><BookingPage /></Chrome>} />
            <Route path="/listo" element={<Chrome><ReadyPage /></Chrome>} />
            <Route
              path="/panel"
              element={<Chrome><AdminSessionGate><PanelPage /></AdminSessionGate></Chrome>}
            />
            <Route
              path="/panel/contactos"
              element={<Chrome><AdminSessionGate><ContactsPage /></AdminSessionGate></Chrome>}
            />
            <Route
              path="/panel/tutores"
              element={<Chrome><AdminSessionGate><AdminPage /></AdminSessionGate></Chrome>}
            />
            <Route path="/gracias-guia" element={<Chrome><GuideThanksPage /></Chrome>} />
            <Route path="/privacidad" element={<Chrome><PrivacyPage /></Chrome>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <WhatsAppFloat />
        </div>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
